var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.875C19 0.84375 18.145 0 17.1 0H1.9C0.855 0 0 0.84375 0 1.875V13.125C0 14.1562 0.855 15 1.9 15H17.1C18.145 15 19 14.1562 19 13.125V1.875ZM17.1 1.875L9.5 6.5625L1.9 1.875H17.1ZM17.1 13.125H1.9V3.75L9.5 8.4375L17.1 3.75V13.125Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeEmailIcon);
export default __webpack_public_path__ + "static/media/employeEmailIcon.45d65c40b7fc781ecac345dcb2ce9a09.svg";
export { ForwardRef as ReactComponent };